export const joinReasons = [
  { id: 1, value: 'Living with cancer' },
  { id: 2, value: 'Carer' },
];
